import { CascadiaJsonFormContext } from "@certn/forms";
import { ArrayControlProps } from "@jsonforms/core";
import { withJsonFormsArrayControlProps } from "@jsonforms/react";
import { withCascadiaControlProps } from "@certn/forms/src/wrappers/withCascadiaControlProps";
import { useContext } from "react";

import { EmploymentDocumentsControl } from "./EmploymentDocumentsControl";
import { EmploymentDocumentTypeControl } from "./EmploymentDocumentTypeControl";
import { EmploymentDocumentsSummaryControl } from "./EmploymentDocumentsSummaryControl";

function EmploymentDocumentsControlInternal(props: ArrayControlProps) {
  const { isSummary } = useContext(CascadiaJsonFormContext);

  if (isSummary) {
    return <EmploymentDocumentsSummaryControl {...props} />;
  }

  return <EmploymentDocumentsControl {...props} />;
}

export const EmploymentDocumentsControlRenderer =
  withJsonFormsArrayControlProps(EmploymentDocumentsControlInternal);

export const EmploymentDocumentTypeControlRenderer = withCascadiaControlProps(
  EmploymentDocumentTypeControl,
  { treatNullAsEmpty: true }
);
